import { z } from 'zod';
import { PAYMENT_METHODS } from '../constants.js';

export const appSettingsSchema = z.object({
  newBadgeExpiryDays: z.number().int().min(1).max(365),
  reviewUrl: z.string().url().max(500).optional().nullable(),
  emailLogoUrl: z.string().url().max(500).optional().nullable(),
  maintenanceMode: z.boolean(),
  maintenanceMessage: z.string().max(500).optional().nullable(),
  // Payment methods shown at checkout. An empty list is rejected — at least
  // one method must stay enabled or customers can't pay.
  enabledPaymentMethods: z.array(z.enum(PAYMENT_METHODS)).min(1),
});

export const appSettingsUpdateSchema = appSettingsSchema.partial();

export type AppSettings = z.infer<typeof appSettingsSchema>;
export type AppSettingsUpdateInput = z.infer<typeof appSettingsUpdateSchema>;

export const APP_SETTINGS_DEFAULTS: AppSettings = {
  newBadgeExpiryDays: 15,
  reviewUrl: null,
  emailLogoUrl: null,
  maintenanceMode: false,
  maintenanceMessage: null,
  enabledPaymentMethods: ['mbway', 'multibanco', 'credit_card'],
};

export const PUBLIC_APP_SETTINGS_KEYS = [
  'newBadgeExpiryDays',
  'maintenanceMode',
  'maintenanceMessage',
  'enabledPaymentMethods',
] as const;
export type PublicAppSettingsKey = (typeof PUBLIC_APP_SETTINGS_KEYS)[number];
